<form autocomplete="nope" class="material" #form="ngForm" *ngIf="documentTag">
    <mat-form-field class="w-100">
        <mat-label>{{ 'document.tag' | appTranslate }}</mat-label>
        <input type="text" required name="documentTagName" [(ngModel)]="documentTag.name" #docName="ngModel" matInput />
    </mat-form-field>
</form>
